import { FaRegSnowflake } from 'react-icons/fa'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmFrozen = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={FaRegSnowflake} />
))
